import React from "react";
import { Link } from 'react-router-dom'
// import ReactTooltip from 'react-tooltip';
import * as Scroller from 'react-scroll'
import { Link as Scroll } from 'react-scroll'

import em1 from '../../assets/img/emoji1.svg'
import em2 from '../../assets/img/emoji2.svg'
import em3 from '../../assets/img/emoji3.svg'
import em4 from '../../assets/img/emoji4.svg'
import em5 from '../../assets/img/emoji5.svg'
import em6 from '../../assets/img/emoji6.svg'
import scroll from '../../assets/img/arrow_down.svg'
import scrollUp from '../../assets/img/arrow_up.svg'


function Home() {

    const [emoji, setEmoji] = React.useState(em2)
    const [soft, setSoft] = React.useState("Software")
    const [dev, setDev] = React.useState("Developer")
    const [workList] = React.useState([
        {
            path: "Work/mycircles",
            title: "MyCircles",
            content: "Mobile Application"
        },
        {
            path: "Work/oudi",
            title: "Oudi",
            content: "Mobile Application"
        },
        {
            path: "Work/broadcast",
            title: "Broadcast!",
            content: "Apple Watch App"
        },
        {
            path: "Work/medusa",
            title: "Medusa",
            content: "SAAS"
        },
        {
            path: "Work/gravity",
            title: "Gravity",
            content: "SAAS"
        },
        {
            path: "Work/vigho",
            title: "Vigho",
            content: "Web Application"
        },
        {
            path: "Work/kallwealth",
            title: "Kallwealth",
            content: "Web Application"
        },
        {
            path: "Work/davidayo",
            title: "DavidAyo",
            content: "Personal Website"
        },
        {
            path: "https://apps.apple.com/ng/app/drivemasterpro/id1502888290",
            title: "Drive Master",
            content: "Mobile Application"
        },
        {
            path: "https://dqve.github.io/30-Days-30-Projects/",
            title: "Design Playground",
            content: "UI/UX and Websites"
        },
        {
            path: "https://expo.dev/@davidayo?tab=snacks",
            title: "Mobile Playground",
            content: "Mobile Applications"
        }
    ])

    // let toolTip = React.useRef();

    function emojiFunc() {
        const items = [em2, em2, em3, em3, em1, em4, em5, em6]
        let value = items[Math.floor(Math.random() * items.length)]
        return value === emoji ? items[Math.floor(Math.random() * items.length)] : value
    }

    React.useEffect(() => {
        const items = [em2, em2, em3, em3, em1, em4, em5, em6]
        let final = items[Math.floor(Math.random() * items.length)]
        setEmoji(final)
        Scroller.animateScroll.scrollToTop()
    }, [])



    return (
        <>
            <div id="hero">

                <div className="home-div animated delay12 fadeInIn">

                    <img data-tip data-for='emoji' className="image" onMouseOver={() => setEmoji(emojiFunc())} onClick={() => setEmoji(emojiFunc())} src={emoji} alt="David Avatars" />
                    {/* <ReactTooltip id='emoji' type='warning' effect='solid'>
                        <span>Hiya 👋🏽.</span>
                    </ReactTooltip> */}
                </div>
                {/* <div>
                    <div className=" custom-tooltip-div">
                        <span>Hiya 👋🏽.</span>
                        </div>
                    <button onClick={() => { ReactTooltip.show(toolTip.current) }}>Chi</button>
                    <a data-tip data-for='tip'> இдஇ </a>
                </div> */}

                <div className="title">
                    <div ms={10} className="line animated fadeInLeft soft" onMouseOver={() => setSoft("David")} onMouseOut={() => setSoft("Software")} >
                        {soft}
                    </div>
                    <div className="line animated fadeInRight eng" onMouseOver={() => setDev("Ayo")} onMouseOut={() => setDev("Developer")} >
                        {dev}
                    </div>
                </div>
            </div>
            <div id="selected_work">
                <div className="work_line_first animated fadeInUp" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div className="selected_work_title" style={{ float: "left", height: "fit-content", lineHeight: "auto" }}>Selected work</div>
                    <div className="logo" style={{ float: "right", width: "fit-content" }}>
                        <Scroll to="works" spy={true} smooth={true}>
                            <img className="image" src={scroll} alt="scroll down" />
                        </Scroll>
                    </div>
                </div>
                <div id="works">
                    {workList.length > 0 ?
                        workList.map((each, key) => (
                            key < 8 ?
                                <div key={key} className="work_line animated fadeInUp">

                                    <Link to={each.path}>
                                        <div className="project_title">{each.title}</div>
                                        <div className="project_info">{each.content}</div>
                                    </Link>
                                </div>
                                :
                                <div key={key} className="work_line animated fadeInUp">

                                    <a href={`${each.path}`} target='_blank' rel="noreferrer">
                                        <div className="project_title">{each.title}</div>
                                        <div className="project_info">{each.content}</div>
                                    </a>
                                </div>

                        ))
                        :
                        <div className="work_line animated fadeInUp">
                            <Link to={""}>
                                <div className="project_title">DavidAyo</div>
                                <div className="project_info">Personal Website</div>
                            </Link>
                        </div>

                    }
                </div>
                <div className="logo" style={{ float: "right", width: "fit-content" }}>
                <Scroll to="navigation" spy={true} smooth={true}>
                    <img className="image" src={scrollUp} style={{marginTop: 50}} alt="scroll down" />
                </Scroll>
            </div>
            </div>
            
        </>
    )
}

export default Home
